const pointHistoryRouter = [
    {
        path: "list-point_history",
        name: "list",
        component: () => import("@/views/admin/point_history"),
        default: true,
        meta: {
            model: "point_history",
            // requiresAuth: true,
        },
    },
    {
        path: "list-point_history/add",
        name: "add",
        component: () => import("@/views/admin/point_history/function"),
        default: true,
        meta: {
            model: "point_history",
            // requiresAuth: true,
        },
    },
    {
        path: "list-point_history/edit/:id",
        name: "edit",
        component: () => import("@/views/admin/point_history/function"),
        default: true,
        meta: {
            model: "point_history",
            // requiresAuth: true,
        },
    },
];
export default pointHistoryRouter;